module.exports = __webpack_public_path__ + "img/wps@2x.983a5eed.png";